module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/spot01_stay-179385e186f84bc457acacc5beab7824.jpg";